import React from "react";
import { useLanguage } from "../../context/LanguageContext";
import { Box, Typography, Stack, useTheme } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHtml5,
  faCss3Alt,
  faJs,
  faReact,
  faPhp,
} from "@fortawesome/free-brands-svg-icons";

export default function Tecnologias({ id }) {
  const theme = useTheme();
  const { language } = useLanguage();
  const iconStyle = {
    fontSize: "3rem",
    transition: "transform 0.3s ease, color 0.3s ease",
    "&:hover": {
      transform: "scale(1.1)",
      color: theme.palette.error.main,
    },
  };
  const textsTecnologias = {
    es: {
      titulo: "Tecnologías",
      lenguajes: "Lenguajes de programación",
      librerias: "Librerías y frameworks",
      software: "Softwares",
      aprendiendo: "En proceso de aprendizaje",
    },
    en: {
      titulo: "Technologies",
      lenguajes: "Programming Languages",
      librerias: "Libraries and Frameworks",
      software: "Softwares",
      aprendiendo: "Currently Learning",
    },
  };

  const imageStyle = {
    width: "60px",
    height: "60px",
    objectFit: "contain",
    filter: theme.palette.mode === "dark" ? "brightness(0.9)" : "none",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.1)",
    },
  };

  return (
    <Box
      id={id}
      component="section"
      data-aos="fade-left"
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: { xs: 3, sm: 4, md: 6 },
        backgroundColor: "transparent",
        color: theme.palette.text.primary,
        transition: "background-color 0.3s ease, color 0.3s ease",
      }}
    >
      <Box sx={{ maxWidth: "800px", width: "100%" }}>
        <Typography
          variant="h3"
          component="h2"
          sx={{
            fontFamily: theme.typography.fontFamily[0],
            fontWeight: 700,
            fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
            background: theme.palette.secondary.main,
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            mb: 4,
            textTransform: "uppercase",
          }}
        >
          {textsTecnologias[language].titulo}
        </Typography>

        <Typography variant="h6" sx={{ mb: 2 }}>
          {textsTecnologias[language].lenguajes}
        </Typography>
        <Stack
          direction="row"
          spacing={4}
          justifyContent="center"
          alignItems="center"
          sx={{ mb: 4 }}
        >
          <Box sx={iconStyle}>
            <FontAwesomeIcon icon={faHtml5} />
          </Box>
          <Box sx={iconStyle}>
            <FontAwesomeIcon icon={faCss3Alt} />
          </Box>
          <Box sx={iconStyle}>
            <FontAwesomeIcon icon={faJs} />
          </Box>
        </Stack>

        <Typography variant="h6" sx={{ mb: 2 }}>
          {textsTecnologias[language].librerias}
        </Typography>
        <Stack
          direction="row"
          spacing={4}
          justifyContent="center"
          alignItems="center"
          sx={{ mb: 4 }}
        >
          <Box sx={iconStyle}>
            <FontAwesomeIcon icon={faReact} />
          </Box>
          <Box
            component="img"
            src="/images/logos/Tailwind.svg"
            alt="Tailwind"
            sx={imageStyle}
          />
        </Stack>

        <Typography variant="h6" sx={{ mb: 2 }}>
          {textsTecnologias[language].software}
        </Typography>
        <Stack
          direction="row"
          spacing={4}
          justifyContent="center"
          alignItems="center"
          sx={{ mb: 4 }}
        >
          <Box
            component="img"
            src="/images/logos/krita.png"
            alt="Krita"
            sx={imageStyle}
          />
          <Box
            component="img"
            src="/images/logos/photoshopLogo.png"
            alt="Photoshop"
            sx={imageStyle}
          />
        </Stack>

        <Typography
          variant="body1"
          sx={{
            fontWeight: 600,
            color: theme.palette.text.secondary,
            fontStyle: "italic",
            mt: 2,
          }}
        >
          {textsTecnologias[language].aprendiendo}
        </Typography>
      </Box>
    </Box>
  );
}
